export default __webpack_public_path__ + "static/avani-fd61b37b9896edf533205539db73b8d0.jpg";